module.exports = __webpack_public_path__ + "assets/images/scan_error.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/scan_error.png
// module id = 69
// module chunks = 1